import React from 'react'
import styles from './MicrositeUsageBar.module.css'

/**
 * MicrositeUsageBar
 * Horizontal progress bar showing usage against a plan limit —
 * used on MicrositePlan for storage, API calls, and emails.
 *
 * Usage:
 *   <MicrositeUsageBar label="Storage" used={3.2} max={50} unit="GB" />
 */
const MicrositeUsageBar = ({ label, used = 0, max = 1, unit = '' }) => {
    const pct = max > 0 ? Math.min(100, (used / max) * 100) : 0
    const tone = pct >= 90 ? 'danger' : pct >= 70 ? 'warning' : 'good'

    return (
        <div className={styles.wrap}>
            <div className={styles.labelRow}>
                <span className={styles.label}>{label}</span>
                <span className={styles.figures}>
                    {used}{unit} <span className={styles.figuresMax}>/ {max}{unit}</span>
                </span>
            </div>
            <div className={styles.track}>
                <div className={`${styles.fill} ${styles[`fill_${tone}`]}`} style={{ width: `${pct}%` }} />
            </div>
        </div>
    )
}

export default MicrositeUsageBar